"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseHttpsSubDomain = exports.getSubdomain = exports.default = void 0;
var AMEX_DOMAIN = '.americanexpress.com';
var amexDomainRegex = new RegExp('https://.*.americanexpress.com');
var DEFAULT_SUBDOMAINS = {
  PROD: 'global',
  LOCAL: 'g10-dev'
};

var parseHttpsSubDomain = function parseHttpsSubDomain(origin, domain) {
  var endIndex = origin.indexOf(domain);
  return origin.slice(8, endIndex);
};

exports.parseHttpsSubDomain = parseHttpsSubDomain;

var getSubdomain = function getSubdomain(origin) {
  var env;

  if (origin === 'http://localhost:3000') {
    // use 'g10-dev' for local
    env = DEFAULT_SUBDOMAINS.LOCAL;
  } else if (!amexDomainRegex.test(origin)) {
    // domain not recognized
    env = DEFAULT_SUBDOMAINS.PROD; // default to PROD, do not expose develop/SL
  } else {
    // valid domain, parse out subdomain
    env = parseHttpsSubDomain(origin, AMEX_DOMAIN);
  }

  return env;
};

exports.getSubdomain = getSubdomain;
var _default = getSubdomain;
exports.default = _default;